import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

type SkipperURLPathKeys = {
    id: 'id';
    unitId: 'unitId';
    activityId: 'activityId';
    gradingSchemeId: 'gradingSchemeId';
    batchId: 'batchId';
    submissionId: 'submissionId';
    sessionId: 'sessionId';
};

type Infer<R extends any> = R extends string ? string : never;

type QueryKeys<Type> = {
    [Property in keyof Type]: Infer<Type[Property]>;
};

export function useQueryParams<
    T extends keyof SkipperURLPathKeys,
    M extends QueryKeys<SkipperURLPathKeys>,
>(keys: T[]): NonNullable<M> {
    const router = useRouter();

    const finalResult = useMemo(() => {
        const result: { [key: string]: string } = {};
        keys.forEach((k) => {
            const m = router?.query[k];
            if (Array.isArray(m)) {
                const [r] = m;
                result[k] = r;
            } else if (m) {
                result[k] = m;
            }
        });
        return result;
    }, [router.query]);

    return finalResult as NonNullable<M>;
}
